module.exports = __webpack_public_path__ + "img/img0.5ec06992.jpg";